var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVoiceChanger = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinejoin: "round",
  strokeWidth: 0.9,
  d: "M6.196 3.53c0 .955-.76 1.729-1.696 1.729s-1.695-.774-1.695-1.73c0-.955.759-1.729 1.695-1.729.937 0 1.696.774 1.696 1.73ZM4.5 6.741c-1.443 0-2.58.768-3.18 1.908-.406.77.287 1.551 1.143 1.551h4.074c.856 0 1.55-.781 1.144-1.55-.6-1.141-1.738-1.909-3.18-1.909Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: 0.9,
  d: "M9.371 3a3 3 0 0 1 0 4.243M7.957 4.414a1 1 0 0 1 0 1.414"
})));
export default SvgVoiceChanger;